<div
    *ngIf="!!grid"
    #toolbar
    [hidden]="grid.options.config?.toolbar?.hidden !== false"
    class="ag-header ag-header-row tt-grid__toolbar"
    role="row"
    aria-rowindex="0"
    style="display: block; top: 0; left: 0; height: fit-content; min-height: fit-content; width: 100%; overflow: visible; z-index: 3"
>
    <ng-container *ngIf="grid.options.data!.columnDefinitions.length > 0 && grid.initializationComplete">
        <tt-grid-button *ngIf="grid.options.config?.toolbar?.excelExport === true" ttTooltipText="export_to_excel" ttIcon="fal fa-file-excel" (ttClick)="exportToExcel($event)"></tt-grid-button>
        <tt-grid-button *ngIf="grid.options.config?.toolbar?.pdfExport === true" ttTooltipText="export_to_pdf" ttIcon="fal fa-file-pdf" (ttClick)="exportToPdf($event)"></tt-grid-button>
        <tt-grid-button
            *ngIf="grid.options.config?.toolbar?.filter === true && grid.options.kendo?.filterable !== false"
            ttTooltipText="toggle_filtering"
            ttIcon="fal fa-filter"
            (ttClick)="toggleFloatingFilters($event)"
        ></tt-grid-button>
        <tt-grid-button
            *ngIf="grid.options.config?.toolbar?.filter === true && hasActiveFilters && grid.options.kendo?.filterable !== false"
            ttTooltipText="clear_all_filters"
            ttIcon="fal fa-filter"
            ttSecondIcon="fal fa-times tt-grid__button-icon--secondary"
            class="tt-grid-button--filter-remove"
            (ttClick)="clearAllFilters($event)"
        ></tt-grid-button>
        <tt-grid-button
            *ngIf="grid.options.config?.toolbar?.headers === true"
            ttTooltipText="toggle_field_name"
            ttIcon="k-icon k-i-group-box"
            (ttClick)="toggleFieldNameAndTitle($event)"
        ></tt-grid-button>
        <tt-grid-button *ngIf="grid.options.config?.toolbar?.refresh === true" ttTooltipText="redraw_data" ttIcon="fal fa-redo" (ttClick)="refreshData($event)"></tt-grid-button>
        <tt-grid-button *ngIf="grid.options.config?.toolbar?.read === true" ttTooltipText="reload_data" ttIcon="fal fa-redo" (ttClick)="readData($event)"></tt-grid-button>
        <tt-grid-button *ngIf="grid.options.config?.toolbar?.rebind === true" ttTooltipText="rebind_grid" ttIcon="fal fa-redo" (ttClick)="rebindGrid($event)"></tt-grid-button>
        <tt-grid-button
            *ngIf="grid.options.config?.toolbar?.add === true || grid.options.config?.toolbar?.addSimple === true"
            ttTooltipText="add_row_over"
            ttIcon="k-icon k-i-insert-up"
            (ttClick)="addRowBefore()"
        ></tt-grid-button>
        <tt-grid-button *ngIf="grid.options.config?.toolbar?.add === true" ttTooltipText="add_row_below" ttIcon="k-icon k-i-insert-down" (ttClick)="addRowAfter()"></tt-grid-button>
        <tt-grid-button
            *ngIf="grid.options.config?.toolbar?.delete === true"
            class="tt-grid-button--delete"
            ttTooltipText="delete_row"
            ttIcon="fal fa-trash"
            (ttClick)="removeSelectedRows()"
        ></tt-grid-button>
        <tt-grid-button *ngIf="grid.options.config?.toolbar?.save === true" class="tt-grid-button--save" ttTooltipText="save" ttIcon="fal fa-save" (ttClick)="saveAllChanges($event)"></tt-grid-button>
        <tt-grid-button
            *ngIf="grid.options.config?.toolbar?.wrapping === true"
            ttTooltipText="toggle_text_wrapping"
            ttIcon="k-icon k-i-text-wrap"
            (ttClick)="toggleTextWrapping($event)"
        ></tt-grid-button>
        <tt-grid-button
            *ngIf="grid.options.config?.toolbar?.autosizeColumns === true"
            ttTooltipText="autosize_all_columns"
            ttIcon="fal fa-arrows-h"
            (ttClick)="autoSizeAllColumns($event)"
        ></tt-grid-button>
        <tt-grid-button
            *ngIf="grid.options.config?.toolbar?.layouts === true"
            ttTooltipText="ttgrid_modal_layouts_heading"
            ttIcon="k-icon k-i-table-properties"
            (ttClick)="openColumnLayoutDialog($event)"
        ></tt-grid-button>
        <tt-grid-button *ngIf="grid.options.config?.toolbar?.print === true" ttId="print" ttTooltipText="print" ttIcon="fal fa-print" (ttClick)="openPrintDialog($event)"></tt-grid-button>

        <tt-grid-button
            *ngFor="let button of buttons"
            [ttId]="button.name"
            [ttText]="button.text ?? ''"
            [ttTranslateText]="button.translate ?? true"
            [ttTooltipText]="button.tooltip ?? ''"
            [ttTranslateTooltipText]="button.translateTooltip ?? true"
            [ttIcon]="button.icon ?? ''"
            [ttType]="button.type"
            [ttKind]="$any(button.cssClass)"
            [ttRowByRow]="button.rowbyrow"
            [ttReadOnClose]="button.read_on_close"
            [ttRebindOnClose]="button.rebind_on_close"
            [ttGoto]="button.state"
            [ttGotoParms]="button.state_params"
            [ttP2DatataskKeyno]="button.p2_datatask_keyno"
            [ttModalComponent]="button.component"
            [ttModalHeight]="button.modal_height || undefined"
            [ttModalWidth]="button.modal_width || undefined"
            [ttDisableIfNoSelected]="button.disable_if_no_selected"
            [ttSaveSelectedRows]="button.save_selected_rows"
            [ttDisabled]="button._disabled"
            (ttClick)="onClick(button, $event)"
            [ttItems]="$any(button).buttons"
            [grid]="grid"
        ></tt-grid-button>

        <ng-content select="[toolbarButtons]"></ng-content>

        <tt-grid-toggle
            *ngFor="let toggle of toggles"
            [ttId]="toggle.name"
            [ttStateIndex]="toggle.state ?? 0"
            (ttStateIndexChange)="toggle.state = $event"
            [ttKind]="$any(toggle.cssClass)"
            [ttDisabled]="toggle._disabled"
        >
            <tt-grid-toggle-state
                *ngFor="let state of toggle.states; index as i"
                [ttText]="state.text"
                [ttTranslateText]="state.translate ?? true"
                [ttIcon]="state.icon"
                (ttClick)="state.func(i)"
            ></tt-grid-toggle-state>
        </tt-grid-toggle>
    </ng-container>
</div>
